const SUPPORTED_LOCALES = new Set([
  'cn',
  'de',
  'en',
  'es',
  'fr',
  'he',
  'hi',
  'id',
  'ja',
  'ne',
  'nl',
  'pl',
  'pt',
  'ru',
  'ta',
  'te',
  'zh',
]);

const normalizeLocale = (value?: string | null) => {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return 'en';
  const base = raw.split('-')[0];
  return SUPPORTED_LOCALES.has(base) ? base : 'en';
};

export const getShareLocale = (language?: string | null) => {
  if (typeof window !== 'undefined') {
    const firstPathSegment = window.location.pathname.split('/').filter(Boolean)[0];
    if (SUPPORTED_LOCALES.has(firstPathSegment)) return firstPathSegment;
  }
  return normalizeLocale(language);
};

export const buildLocalizedHomepageShareUrl = (
  channel: string,
  language?: string | null,
  campaign = 'friend_share',
) => {
  const locale = getShareLocale(language);
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://sarvalok.com';
  const url = new URL(`/${locale}/`, origin);
  url.searchParams.set('utm_source', channel);
  url.searchParams.set('utm_medium', 'share');
  url.searchParams.set('utm_campaign', campaign);
  return url.toString();
};
